<div class="ab-list-item-inner flex w-100 activity-type--relationship">
  <span class="ab-list-item__icon">
    <i class="icon fal fa-calendar-star"></i>
  </span>
  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{ item?.user?.name }}</span> marked <strong class="color--gray--006"><i
          class="fa far {{ getIcon(getResponseStatus(item?.payload.status)) }}"></i> {{ getLabel(getResponseStatus(item?.payload.status)) }}</strong> for
      <app-activity-target-link [target]="item.target">{{ item?.target | fullName }}</app-activity-target-link>
      to
      <a routerLink="/events/view"
        [queryParams]="{ campaignId: item?.target?.campaignContextId, eventId: item?.payload.event?.id }"
        class="affected-user user-profile-link">
        {{ item?.payload.event?.name }}
      </a>
    </div>
    <div class="details-simple mt-0075">
      <p class="has-intro-icon color--gray--009 txt-14 pl-0125">
        <i class="fal fa-clock intro-icon mt-0025"></i>
        {{item?.payload.event | eventStartEndTime}}
      </p>
    </div>
  </div>
  <app-activity-event-timestamp [item]="item" class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
